// Setting count for add all to cart products
var addToCartCount;
var addAllToCartLink;
var url_string = window.location.href;
var url = new URL(url_string);
var tangent_recommended_products;
let selected_pdt;
var imgid = url.searchParams.get("id");
var resp_id = url.searchParams.get("resp_id");

var domainUrl = document.getElementById("site-url").innerText;
var language_isocode = document.getElementById("site-iso-code").innerText;
var default_addToCartText = "Add to cart";
var default_addedToCartText = "Added to Cart!";
let outOfStock = "Out of Stock";

if(language_isocode=="es"){
    default_addToCartText = "Añadir";
}

var domainCurrency;

// Default url path for product
var variant_product_url;

var product_options_map = {};

var option1array = [];
var option2array = [];
var option3array = [];

var variantOption1_div;
var variantOption2_div;
var variantOption3_div;

// Options name mapped to variant id
var option2_variant_map = {};

if(resp_id != null){
    
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+resp_id+"&self_serve=true";

    var xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
           if (xmlhttp.status == 200) {
            var jsonData = JSON.parse(xmlhttp.responseText);
            
            document.getElementById('tangent-selfie-container-div').innerHTML = jsonData.selfie_html;
            tangent_recommended_products = jsonData.products;
            
            domainCurrency = document.getElementById("site-currency").innerText;

            var allToCart = domainUrl+"/cart/add?id[]=";
            // DISABLE LOADER 
            document.getElementById("tangent_page_loader").style.display="none";
            if (tangent_recommended_products.length > 0) {

                    document.getElementById('tangent-add-all-to-cart').style.display = "block";

                    selected_pdt = {};
                    active_product_count = 0;
                    var select_variant_obj;
                    
                    for (var p = 0; p < tangent_recommended_products.length; p++) {
                        select_variant_obj = tangent_recommended_products[p].variants[0];
                        option1array = [];
                        option2array = [];
                        option3array = [];
                        variant_product_url = domainUrl + '/products/';
                        var variant_price;

                        var imgsrc = "";
                        if (domainCurrency == "") {
                            domainCurrency = '$';
                        }
                        if (tangent_recommended_products[p].images != undefined) {
                            imgsrc = getVariantImage(tangent_recommended_products[p].variants[0].image_id,tangent_recommended_products[p]);
                        }
                        else{
                            imgsrc = "https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp";
                        }

                        variantOption1_div = document.createElement("div");
                        variantOption1_div.classList.add("tangent_option_div");

                        var variant_checkbox_elm = document.getElementById('tangent_variant_view_check');

                        variant_price = tangent_recommended_products[p].variants[0].price;
                        variant_product_url = variant_product_url + tangent_recommended_products[p].handle + "?variant=" + tangent_recommended_products[p].variants[0].id;

                        let selectedVariant = isSelectedVariantPresent(jsonData.selected_variants, tangent_recommended_products[p].id)
                        
                        // CHECK FOR VARIANT ENABLED
                        if (selectedVariant.length && tangent_recommended_products[p].variants.length > 1) {
                            if (variant_checkbox_elm != undefined && variant_checkbox_elm != null) {
                                if (variant_checkbox_elm.value==true || variant_checkbox_elm.value=="true") {
                                    var variants_div = document.createElement("div");
                                    variants_div.id = 'tangent_checkout_variants_div_' + p;
                                    variants_div.classList.add("tangent_checkout_variants_div");
                                    variants_div.style.display = "none";

                                    var variantsub_div = document.createElement("div");
                                    variants_div.appendChild(variantsub_div);
                                    var _variants = tangent_recommended_products[p].variants;
                                    var option1_ele_arr = [];
                                    var option2_ele_arr = [];
                                    var option3_ele_arr = [];

                                    var option_obj = {};

                                    variants_div.style.display = "block";

                                    // Product Option 1 Name Element
                                    var option1_name = document.createElement("p");
                                    option1_name.id = "optionName_variant:product_" + p;
                                    option1_name.innerText = tangent_recommended_products[p].options[0].name + ":";
                                    option1_name.classList.add("tangent_option_name");
                                    variantOption1_div.append(option1_name);

                                    // Creating values for product option 1 
                                    var option1_values = tangent_recommended_products[p].options[0].values;
                                    for (var opt1v = 0; opt1v < option1_values.length; opt1v++) {
                                        var variants_option1 = document.createElement("img");
                                        variants_option1.id = "product_" + p + ":option_" + opt1v;
                                        variants_option1.title = option1_values[opt1v];
                                        var img_name =option1_values[opt1v].toLowerCase().replace(" ","-");
                                        variants_option1.src = "https://osmosisbeauty.com/cdn/shop/files/"+img_name+".png";//option1_values[opt1v];
                                        variants_option1.classList.add("tangent_option");
                                        variants_option1.classList.add("product_" + p + "v1");
                                        variants_option1.classList.add("tangent_options_1");

                                        if (!option1array.includes(option1_values[opt1v])) {
                                            option1array.push(option1_values[opt1v]);
                                            option1_ele_arr.push(variants_option1);
                                            variantOption1_div.appendChild(variants_option1);
                                        }
                                    }
                                    if (option1_ele_arr.length > 0) { option_obj["option1"] = option1_ele_arr; }

                                    product_options_map[tangent_recommended_products[p].id] = option_obj;


                                    // All options for the product
                                    var options1;

                                    // When product has no variant previously selected
                                    // Default Select Option 1
                                    if (product_options_map[tangent_recommended_products[p].id].option1 != undefined) {
                                        if (product_options_map[tangent_recommended_products[p].id].option1.length > 0) {
                                            options1 = product_options_map[tangent_recommended_products[p].id].option1;
                                            for(var sv=0;sv<tangent_recommended_products[p].variants.length;sv++){
                                              if(String(tangent_recommended_products[p].variants[sv].id) == selectedVariant[0]){
                                                for(var opt=0;opt<options1.length;opt++){
                                                  if(tangent_recommended_products[p].variants[sv].title.includes(options1[opt].title)){
                                                    options1[opt].classList.add("tangent_selected-variant");
                                                  }
                                                }
                                              }
                                            }
                                        }
                                    }

                                    selected_pdt[tangent_recommended_products[p].id] = _variants[0].id + "";
                                    select_variant_obj = _variants[0];
                                    // By Default
                                    variant_price = _variants[0].price;
                                    // ADD SELECTED VARIANT PRICE
                                    for (let i = 0; i < selectedVariant.length; i++) {
                                      tangent_recommended_products[p].variants.forEach((variant) => {
                                          if (selectedVariant[i] == variant.id) {
                                            variant_price = variant.price;
                                          }
                                      }                                                );
                                    }
                                    variant_product_url = variant_product_url + tangent_recommended_products[p].handle + "?variant=" + _variants[0].id;

                                    variantsub_div.appendChild(variantOption1_div);

                                }
                            }
                        }
                      
                        if (selected_pdt[tangent_recommended_products[p].id] == null) {
                            selected_pdt[tangent_recommended_products[p].id] = tangent_recommended_products[p].variants[0].id;
                        }
                      
                        if (tangent_recommended_products[p].variants.length > 1 || tangent_recommended_products[p].variants.length == 1) {
                            var product_html;
                            if(domainUrl==undefined){
                                domainUrl = document.getElementById("site-url").innerText;
                            }
                            product_html = '<div><a id="url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="image_tangent_product_' + p + '" src="' + imgsrc + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + tangent_recommended_products[p].title + '</b></p><p id="price_tangent_product_' + p + '" class="tangent_product_price_text">' + domainCurrency + variant_price + '</p></a><div id="tangent_product_' + p + '"></div><a class="tangent-product-add-btn-wrapper" id="cart_tangent_product_' + p + '" onclick="addToCart('+tangent_recommended_products[p].id+','+p+')" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="cart_tangent_product_' + p + '_text">' + default_addToCartText + '</p></a>';
                            
                            var element = document.getElementById('tangent-products-section');
                            element.innerHTML = element.innerHTML + product_html;
                            if (selectedVariant.length && tangent_recommended_products[p].variants.length > 1) {
                                if (variant_checkbox_elm != undefined && variant_checkbox_elm != null) {
                                    if (variant_checkbox_elm.value==true || variant_checkbox_elm.value=="true") {
                                        var variant_element = document.getElementById('tangent_product_' + p);
                                        variant_element.appendChild(variants_div);
                                    }
                                }
                            }
                            var cart_button = document.getElementById("cart_tangent_product_" + p);
                            var cart_button_text = document.getElementById("cart_tangent_product_" + p + "_text");
                            
                            if(cart_button!=undefined){
                                // Check if Product is active
                                if (tangent_recommended_products[p].status == "active") {
                                    cart_button.classList.remove("disable-btn-wrapper");
                                    if(select_variant_obj.inventory_policy == "deny"){
                                        if(select_variant_obj.inventory_quantity<1){
                                        if(select_variant_obj.inventory_management!=null){
                                            cart_button_text.innerHTML = outOfStock;
                                            cart_button.classList.add("disable-btn-wrapper");
                                        }
                                        else{
                                            if (active_product_count == 0) {
                                                allToCart += selected_pdt[tangent_recommended_products[p].id];
                                            } else {
                                                allToCart += "&id[]=" + selected_pdt[tangent_recommended_products[p].id];
                                            }
                                            active_product_count++;
                                        }
                                        }
                                        else{
                                            if (active_product_count == 0) {
                                                allToCart += selected_pdt[tangent_recommended_products[p].id];
                                            } else {
                                                allToCart += "&id[]=" + selected_pdt[tangent_recommended_products[p].id];
                                            }
                                            active_product_count++;
                                        }
                                    }
                                    else{
                                        if (active_product_count == 0) {
                                            allToCart += selected_pdt[tangent_recommended_products[p].id];
                                        } else {
                                            allToCart += "&id[]=" + selected_pdt[tangent_recommended_products[p].id];
                                        }
                                        active_product_count++;
                                    }                          
                                }
                                else {
                                    cart_button_text.innerHTML = outOfStock;
                                    cart_button.classList.add("disable-btn-wrapper");
                                }
                            }
                        }

                        // DISABLED FOR NOW
                        //displaying selected products
                        if (selectedVariant.length) {
                            for (let i = 0; i < selectedVariant.length; i++) {
                                tangent_recommended_products[p].variants.forEach((variant) => {
                                    if (selectedVariant[i] == variant.id) {
                                        let imgurl = getVariantImage(variant.image_id,tangent_recommended_products[p]);
                                        let product_url = domainUrl + "/products/" + tangent_recommended_products[p].handle + "?variant=" + variant.id;
                                        
                                        let addTocartClass; 
                                        let buttonText;

                                        if(variant.inventory_policy == "deny"){
                                            if(variant.inventory_quantity<1){
                                              if(variant.inventory_management!=null){
                                                addTocartClass = "disable-btn-wrapper";
                                                buttonText = outOfStock;
                                              }  
                                              else{
                                                buttonText = default_addToCartText;
                                                if (active_product_count == 0) {
                                                    allToCart += variant.id;
                                                } else {
                                                    allToCart += "&id[]=" + variant.id;
                                                }
                                                active_product_count++;
                                              }
                                            }
                                            else{
                                                buttonText = default_addToCartText;
                                                if (active_product_count == 0) {
                                                    allToCart += variant.id;
                                                } else {
                                                    allToCart += "&id[]=" + variant.id;
                                                }
                                                active_product_count++;
                                            }
                                        }
                                        else{
                                            buttonText = default_addToCartText;
                                            if (active_product_count == 0) {
                                                allToCart += variant.id;
                                            } else {
                                                allToCart += "&id[]=" + variant.id;
                                            }
                                            active_product_count++;
                                        }
                                        var product_html;
                                        selected_pdt[tangent_recommended_products[p].id] = variant.id;
                                        variant_price = variant.price;
                                        product_html = '<div><a id="url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + product_url + '"><img id="image_tangent_product_' + p + '" src="' + imgurl + '"  class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + tangent_recommended_products[p].title + '</b></p><p class="tangent-variant-title tangent_variant_title_text"><b>' + variant.title + '</b></p><p id="price_tangent_product_' + p + '" class="tangent_product_price_text">' + domainCurrency + variant_price + '</p></a><div id="tangent_product_' + p + '"></div><a class="tangent-product-add-btn-wrapper' + addTocartClass + '" id="cart_tangent_product_' + p + '" onclick="addToCart('+tangent_recommended_products[p].id+','+p+')" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="cart_tangent_product_' + p + '_text">' + buttonText + '</p></a>';
                                        var element = document.getElementById('tangent-products-section');
                                        // element.innerHTML = element.innerHTML + product_html;
                                    }
                                })
                            }
                        }
                    }
                    // addAllToCartLink = allToCart;
                    updatingAddAllToCartURL();
                    addToCartCount = active_product_count;
                    // ENABLE EVENT LISTENER FOR ALL OPTIONS
                    var all_options = document.getElementsByClassName('tangent_option');
                    for (var o = 0; o < all_options.length; o++) {
                        all_options[o].addEventListener(
                            'click',
                            function () { changePdtVariant(this); },
                            false
                        );
                    }
                }
                else {
                    document.getElementById('tangent-general-text').innerHTML = "No products found. Please retry!";
                    console.log("No products found Please retry");
                }

                if (jsonData.description != '') {
                    document.getElementById('tangent-checkout-description').style.display = "block";
                    document.getElementById('tangent-checkout-description').innerHTML = jsonData.description;
                }
                else {
                    document.getElementById('tangent-general-text').style.display = "block";
                }
            document.getElementById('retake-quiz-ptag').style.display = "block";
             
           }
           else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
           }
           else {
                console.log('Something else other than 200 was returned');
           }
        }
    };

    xmlhttp.open("GET", checkout_url, true);
    xmlhttp.send();
    
}

function addAllTocartFunction(){
  // event.preventDefault();
    if(addToCartCount>0){
        document.getElementById('tangent-add-all-to-cart').setAttribute("href",addAllToCartLink);
    }
    else{
        var x = document.getElementById("message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
    }
}

function changePdtVariant(ele){
    var cartUrl = domainUrl+"/cart/add?id[]=";
    var eleId = ele.id;
    var arr = eleId.split(":");

    var productNumberText = arr[0];
    var optionNumberText = arr[1];
    var pStart = productNumberText.lastIndexOf('_');
    var oStart = optionNumberText.lastIndexOf('_');
    
    // Product and Option Number
    var pNo = productNumberText.substring(pStart + 1);
    var oNo = optionNumberText.substring(oStart + 1);
    
    //Product ID
    var pId = parseInt(pNo);

    // Product Details
    var pdt = tangent_recommended_products[pId];

    var variant_price= domainCurrency;

    // Product Variants
    var product_variants = pdt.variants;

    // Variant Option Values
    var opt1_value;
    
    // Getting current variant option selections
    // if(product_variants.length>0){
    //     for(var pv=0;pv<product_variants.length;pv++){
    //         if(product_variants[pv].id == selected_pdt[pdt.id]){
    //             opt1_value = product_variants[pv].option1;
    //             console.log("previous selected",opt1_value);
    //         }
    //     }
    // }

    var opt1_list;
    // Identify and Highlight new selection if it is on Option 1 list of Product
    if(ele.classList.contains("tangent_options_1")){
        opt1_list = document.getElementsByClassName("product_"+pId+"v1");
        if(opt1_list.length>0){
            for(var op1=0;op1<opt1_list.length;op1++){
                if(op1==oNo){
                    opt1_list[op1].classList.add("tangent_selected-variant");
                    opt1_value = opt1_list[op1].title;
                }
                else{
                    opt1_list[op1].classList.remove("tangent_selected-variant");
                }
            }
        }
    }
    var option_variant_key;
    // Joining the options found and matching with options to variant mapping to get variant id
    if(opt1_value!=null){
        option_variant_key = opt1_value;
    }

    var add_current_pdt =true;

    // Check if product is active and if not disable add to cart button
    if(pdt.status=="active"){
        document.getElementById("cart_tangent_product_"+pId).classList.remove("disable-btn-wrapper");
        // document.getElementById("cart_tangent_product_"+pId+"2_text").classList.remove("added-to-cart-style");
        
        // Choose variant object from variant list in product object using variant id mapped to product id in product-variant mapping object
        var variant_select;
        if(product_variants.length>0){
            for(var pv=0;pv<product_variants.length;pv++){
                if(product_variants[pv].title.includes(opt1_value)){
                   variant_select = product_variants[pv];
                  break;
                }
            }
        }

        if(variant_select!=undefined){
            // Check quantity available and enable / disable add to cart and add to cart url for add all to cart
            if(variant_select.inventory_quantity<1 && variant_select.inventory_policy =="deny"){
                add_current_pdt = false;
                document.getElementById("cart_tangent_product_"+pId+"_text").innerHTML = "Out of Stock";
                document.getElementById("cart_tangent_product_"+pId).classList.add("disable-btn-wrapper");
            }
            else{
                selected_pdt[pdt.id] = variant_select.id;
                var pdt_cartUrl = cartUrl + selected_pdt[pdt.id];
                document.getElementById("cart_tangent_product_"+pId).classList.remove("disable-btn-wrapper");
                document.getElementById("cart_tangent_product_"+pId+"_text").classList.remove("added-to-cart-style");
                document.getElementById("cart_tangent_product_"+pId+"_text").innerHTML = default_addToCartText;
                document.getElementById('cart_tangent_product_'+pNo).href = pdt_cartUrl;
            }
        }
    }
    else{
        add_current_pdt = false;
        document.getElementById("cart_tangent_product_"+pId+"_text").innerHTML = "Out of Stock";
        document.getElementById("cart_tangent_product_"+pId).classList.add("disable-btn-wrapper");
    }

    var sp=0;
  
    // Loop through product list and update cart url for add all to cart
    for(var p=0;p<tangent_recommended_products.length;p++){ 
        var product_variants = tangent_recommended_products[p].variants;
        // Check if product status , if not skip adding to cart-url
        if(tangent_recommended_products[p].status == "active"){
            // If looping product and selection product same
            if(tangent_recommended_products[p].id == pdt.id){
                if(add_current_pdt){
                    if(sp==0){
                        cartUrl = cartUrl +  selected_pdt[pdt.id];
                    }
                    else{
                        cartUrl = cartUrl + '&id[]='+ selected_pdt[pdt.id];
                    }
                    sp=sp+1;   
                }
            }
            else{
                
                // Loop through variants of looping product and find matched variant from selected product-variant mapping object
                for(var pv=0;pv<product_variants.length;pv++){
                    if(selected_pdt[tangent_recommended_products[p].id]==product_variants[pv].id){
                        if(product_variants[pv].inventory_quantity<1 && product_variants[pv].inventory_policy =="deny"){
                        }
                        else{
                            if(sp==0){
                                cartUrl = cartUrl +  product_variants[pv].id;
                            }
                            else{
                                cartUrl = cartUrl + '&id[]='+ product_variants[pv].id;
                            }
                            sp=sp+1;
                        }                    
                    }
                }  
            }
        }
        variant_product_url = domainUrl+'/products/';
        
        // To Set Variant Price dynamically 
        if(tangent_recommended_products[p].id == pdt.id){
            var variant_pdt_matched = false;
            for(var pv=0;pv<product_variants.length;pv++){
                if(selected_pdt[tangent_recommended_products[p].id]==product_variants[pv].id){
                    variant_pdt_matched = true;
                    variant_price = variant_price + product_variants[pv].price;
                    variant_product_url = variant_product_url+pdt.handle+"?variant="+product_variants[pv].id;
                }
            }
            if(!variant_pdt_matched){
                variant_price = variant_price +product_variants[0].price;
                variant_product_url = variant_product_url+pdt.handle+"?variant="+product_variants[0].id;
            }
            document.getElementById("url_tangent_product_"+pId).href = variant_product_url;
        }
    }
    document.getElementById("price_tangent_product_"+pId).innerHTML = variant_price;
    
    addToCartCount=sp;
    addAllToCartLink = cartUrl;
  }

function updatingAddAllToCartURL(){
  var sp=0;
  var cartUrl = domainUrl+"/cart/add?id[]=";
  // Loop through product list and update cart url for add all to cart
  for(var p=0;p<tangent_recommended_products.length;p++){ 
    var product_variants = tangent_recommended_products[p].variants;
    // Check if product status , if not skip adding to cart-url
    if(tangent_recommended_products[p].status == "active"){
      // Loop through variants of looping product and find matched variant from selected product-variant mapping object
      for(var pv=0;pv<product_variants.length;pv++){
        if(selected_pdt[tangent_recommended_products[p].id]==product_variants[pv].id){
            if(product_variants[pv].inventory_quantity<1 && product_variants[pv].inventory_policy =="deny"){
            }
            else{
                if(sp==0){
                    cartUrl = cartUrl +  product_variants[pv].id;
                }
                else{
                    cartUrl = cartUrl + '&id[]='+ product_variants[pv].id;
                }
                sp=sp+1;
            }                    
        }
      }    
    }
  }
  addAllToCartLink = cartUrl;
  
}

function addToCart(pid, eId){ 
  var click_element = document.getElementById("cart_tangent_product_"+eId+"_text");
  
  // For iphone button event-pointer activity fail
  if(click_element.innerHTML=="Out of Stock"){
    console.log("out of stock item clicked");
    event.preventDefault();
  }
  else{
    var var_id=pid;
    if(selected_pdt[pid]!=undefined){
      var_id= selected_pdt[pid];
    }
    event.preventDefault();
    let formData = {
     'items': [{
      'id': var_id,
      'quantity': 1
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
    
      if(click_element!=undefined){
            click_element.innerHTML = default_addedToCartText;
            click_element.classList.add("added-to-cart-style");
      }
      
      document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
      document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      })); 
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  } 
}

const getVariantImage = (imageId, product) => {
    var pdtImg;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    pdtImg = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            pdtImg = product.image.src;
        }
        else{
            pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(pdtImg== undefined || pdtImg==null){
        pdtImg = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return pdtImg;
}

const isSelectedVariantPresent = (selectedVariants, productId) => {
    for (let key in selectedVariants) {
        if (key == productId) {
            if (selectedVariants[key] == null) {
                return [];
            }
            else if (typeof selectedVariants[key] == "string") {
                return selectedVariants[key].split();
            }
            else {
                return selectedVariants[key];
            }
        }
    }
}

  